export default __webpack_public_path__ + "locales/lv/JavascriptSdk.json?hash=5d1607cb916ced26789a50ebe0b31cb8";